import { listen, isLogoutMessage } from "@sinch/bus";
import { useEffect } from "react";

export const useLogoutHandler = (logout: () => void) => {
  useEffect(() => {
    const unsub = listen(() => {
      logout();
    }, isLogoutMessage);

    return unsub;
  }, [logout]);
};
